export default __webpack_public_path__ + "db22a7675d3a2b2959d3e8451fee958c.png";